import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import './style.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import ConfluentArchitecture from './components/ConfluentArchitecture';
import ContactUs from './pages/ContactUs';
import SIEMWhitepaper from './pages/SIEMWhitepaper';
import IngestionFiltering from './pages/IngestionFiltering';
import FieldDetection from './pages/FieldDetection';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  const isAuthenticated = !!localStorage.getItem('user');

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
    });
  }, []);


  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard/*" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/architecture" element={<ConfluentArchitecture />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/siemReference" element={<SIEMWhitepaper />} />
          <Route path="/ingestionFiltering" element={<IngestionFiltering />} />
          <Route path="/fieldDetection" element={<FieldDetection />} />
        </Routes>
        <Footer />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
